(function () {
  function isScrollable(element) {
    if (!(element instanceof HTMLElement)) return false;

    const style = window.getComputedStyle(element);

    return (
      /(auto|scroll)/.test(style.overflowY) &&
      element.scrollHeight > element.clientHeight
    );
  }

  function canScroll(element, deltaY) {
    if (deltaY < 0) {
      return element.scrollTop > 0;
    }

    if (deltaY > 0) {
      return (
        element.scrollTop + element.clientHeight <
        element.scrollHeight - 1
      );
    }

    return false;
  }

  document.addEventListener(
    'wheel',
    function (event) {
      if (!window.matchMedia('(min-width: 990px)').matches) return;

      const target =
        event.target instanceof Element ? event.target : null;

      if (!target) return;

      const meteorMenu = target.closest('.meteor-menu');

      if (!meteorMenu) return;

      /*
       * Hvis Meteor-menuen på et tidspunkt selv bliver scrollbar,
       * tillader vi scrolling inde i den.
       */
      let element = target;

      while (element && meteorMenu.contains(element)) {
        if (isScrollable(element) && canScroll(element, event.deltaY)) {
          return;
        }

        if (element === meteorMenu) break;

        element = element.parentElement;
      }

      /*
       * Ellers stoppes scroll-hændelsen,
       * så siden bag megamenuen ikke bevæger sig.
       */
      event.preventDefault();
    },
    {
      passive: false,
      capture: true
    }
  );
})();